import {http} from './config';

export default {
    index:(page=1) => {
        return http.get('api/v1/indiceCorrecaoMonetaria?page=' + page);
    },
    list:() => {
        return http.get('api/v1/indiceCorrecaoMonetaria/listar');
    }
}